import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"
import { cn } from "../../lib/utils"

const Progress = React.forwardRef(({ className, value, shimmer = false, ...props }, ref) => (
    <ProgressPrimitive.Root
        ref={ref}
        className={cn(
            "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
            className
        )}
        {...props}
    >
        <ProgressPrimitive.Indicator
            className="relative h-full w-full flex-1 overflow-hidden bg-primary transition-all"
            style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        >
            {/* Indeterminate sweep — signals active work while the numeric value
                holds steady during long LLM stages. Disabled under reduced motion
                via the .tf-progress-shimmer media query in App.css. */}
            {shimmer && <span className="tf-progress-shimmer" aria-hidden="true" />}
        </ProgressPrimitive.Indicator>
    </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
